import React, { useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useHistory } from "react-router-dom";
import { Card, Row, Col, Button } from 'react-bootstrap';
import { isToday, usePermission } from '../../helpers/common';
import { DataTable, CardContainer, Heading5, Icon, Modal } from '../widgets';
import { getUserId } from "../../helpers/session";
import { getOrganizationList, deleteOrganization } from '../../actions/organization';
import OrganizationRow from './OrganizationRow';
import OrganizationAddEditForm from './OrganizationAddEditForm';
import { SubNav } from '../layout/submenu';

const OrganizationList = (props) => {
    const history = useHistory();
    const { search: { range }, isOrganizationRequesting, organizationList } = props;

    const [showModal, setShowModal] = useState(false);
    const [deleteOrg, setDeleteOrg] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [selectedOrganization, setSelectedOrganization] = useState({
        organization_uuid: "",
        organization_name: "",
        organization_category_Id: null
    });

    const farm_uuid = useSelector(state => state.farm.currentFarm.farm_uuid);

    const allow = usePermission();
    const isAllowCreate = allow("organization", "create");
    const isAllowEdit = allow("organization", "edit");
    const isAllowDelete = allow("organization", "delete");

    let serialNumber = 0;

    useEffect(() => {
        props.actions.getOrganizationList();
    }, []);

    const handleShowModal = () => {
        setShowModal(!showModal);
        setSelectedOrganization({ organization_uuid: "", organization_name: "", organization_category_Id: null });
    };

    const handleEditModal = (id, name, categoryId) => {
        setIsEdit(true);
        setSelectedOrganization({
            organization_uuid: id,
            organization_name: name,
            organization_category_Id: categoryId
        });
        setShowModal(!showModal);
    };

    const handleDeleteModal = (id, name) => {
        setDeleteOrg(!deleteOrg);
        setSelectedOrganization({
            organization_uuid: id,
            organization_name: name
        });
    };

    const handleDeleteConfim = (organizationUuid) => {
        const userId = getUserId();
        const cb = (isSuccess) => {
            if (isSuccess) {
                props.actions.getOrganizationList();
            }
        };
        props.actions.deleteOrganization({ farm_uuid, userId, organizationUuid }, cb);
    };

    return <>
        <CardContainer lg={10} md={10}>
            <Card className="card-list farm-list-view animate animate__zoomIn">
                <Card.Header>
                    <Card.Title>
                        <Row>
                            <Col>
                                <Heading5>Organization List</Heading5>
                            </Col>
                            <Col className='col-4'>
                                <Button
                                    className='btn btn-sm float-right'
                                    variant='danger'
                                    onClick={() => {
                                        const url = `/home/farm/${farm_uuid}/map`;
                                        history.push(url);
                                    }}>
                                    <i className='fa fa-times-circle mr-1' />
                                    Cancel
                                </Button>

                                <span className={'split'}>
                                    <SubNav.Divider className={'splitter float-right'} />
                                </span>

                                {isAllowCreate && isToday(range) ?
                                    <Button
                                        variant="success"
                                        size="sm"
                                        className="float-right"
                                        onClick={() => {
                                            setShowModal(!showModal);
                                            setIsEdit(false);
                                            setSelectedOrganization({ ...selectedOrganization, organization_name: "" });
                                        }}
                                    >
                                        <Icon className="fa fa-plus"></Icon> Add Organization
                                    </Button> : null}




                            </Col>
                        </Row>


                    </Card.Title>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col>
                            <DataTable>
                                <DataTable.Header>
                                    <DataTable.Row>
                                        <DataTable.Cell style={{ width: "100px" }}>#</DataTable.Cell>
                                        <DataTable.Cell style={{ width: "200px" }}>Organization category</DataTable.Cell>
                                        <DataTable.Cell >Organization Name</DataTable.Cell>
                                        {(isAllowEdit || isAllowDelete)
                                            && <DataTable.Cell className="center" style={{ width: "90px" }}>Action</DataTable.Cell>}
                                    </DataTable.Row>
                                </DataTable.Header>
                                <DataTable.Body>
                                    {organizationList.map((organization, i) => {
                                        if (organization) serialNumber++;
                                        return (
                                            <OrganizationRow
                                                key={i}
                                                organization={organization}
                                                serialNumber={serialNumber}
                                                handleEditModal={handleEditModal}
                                                handleDeleteModal={handleDeleteModal}
                                                isAllowDelete={isAllowDelete}
                                                isAllowEdit={isAllowEdit}
                                                farmAssigned={organization.is_farm_assigned}
                                            />
                                        );
                                    })
                                    }
                                </DataTable.Body>
                            </DataTable>
                            {isOrganizationRequesting ? <DataTable.Loading /> :
                                organizationList.length === 0 && <DataTable.RecordsNotFound />}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </CardContainer>

        {(isToday(range) || isEdit) && showModal && <OrganizationAddEditForm onHide={handleShowModal}
            isEdit={isEdit}
            organizationName={selectedOrganization["organization_name"]}
            organizationUuid={selectedOrganization["organization_uuid"]}
            organizationCategoryId={selectedOrganization["organization_category_Id"]}
        />}

        {deleteOrg && <Modal.Confirm
            className="modal-bordered"
            show={deleteOrg}
            onConfirm={() => handleDeleteConfim(selectedOrganization["organization_uuid"])}
            onHide={() => setDeleteOrg(!deleteOrg)}
            iconClassName="fa fa-question"
            title={{ content: "Confirmation" }}
            content={`Do you want to delete ${selectedOrganization["organization_name"]}?`}
        />}
    </>;
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ getOrganizationList, deleteOrganization }, dispatch)
});

const mapStateToProps = state => ({
    isOrganizationRequesting: state.organization.isOrganizationRequesting,
    organizationList: state.organization.organizationList,
    search: { range: state.analyze.searchParams.range }
});

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationList);
